module.exports = __webpack_public_path__ + "img/books.5a4132d9.png";